(function () {
	const _closeButton = document.getElementById('search-close-button');
	const _openButton = document.getElementById('search-open-button');
	const _search = document.getElementById('search');
	
	if (!_openButton || !_search) {
		return;
	}
	
	function init() {
		_openButton.addEventListener('click', show);
		
		_search.addEventListener('click', (event) => {
			if (event.target === _search || event.target === _closeButton) {
				hide();
			}
		});
		
		_search.addEventListener('keyup', (event) => {
			if (event.keyCode === 27) {
				hide();
			}
		});
		
		_search.addEventListener('blur', blur, true);
	}
	
	function blur(event) {
		const _target = event.relatedTarget || event.currentTarget.firstChild.ownerDocument.activeElement;
		
		if (!util.hasParent(_target, _search)) {
			event.preventDefault();
			event.target.focus();
		}
	}
	
	function hide() {
		_openButton.setAttribute('aria-expanded', 'true');
		util.removeClass(_search, 'is-visible');
		_search.setAttribute('aria-hidden', 'true');
		
		_openButton.focus();
	}
	
	function show() {
		_openButton.setAttribute('aria-expanded', 'true');
		util.addClass(_search, 'is-visible');
		_search.setAttribute('aria-hidden', 'false');
		
		_search.querySelector('input').focus();
	}
	
	init();
}());